import React from 'react';
import PropTypes from 'prop-types';

class ClickOutComponent extends React.Component {
    constructor(props) {
        super(props);
        this.windowListener = this.windowListener.bind(this);
        this.touchEvent = 'ontouchstart' in window ? 'touchstart' : 'click';
    }

    componentDidMount() {
        window.addEventListener(this.touchEvent, this.windowListener);
    }

    componentWillUnmount() {
        window.removeEventListener(this.touchEvent, this.windowListener);
    }

    windowListener(e) {
        if (!this.childrenWrapper.contains(e.target)) {
            this.props.onClickOut();
        }
    }

    render() {
        return (
            <div
                ref={(s) => {
                    this.childrenWrapper = s;
                }}
            >
                {this.props.children}
            </div>
        );
    }
}

ClickOutComponent.propTypes = {
    children: PropTypes.node.isRequired,
    onClickOut: PropTypes.func.isRequired,
};

export default ClickOutComponent;
